jQuery(function ($) {
  // Nous utiliserons ce conteneur pour afficher les notifications
  const $body = $('body');

  /**
   * Affiche une popup flottante (utilisation simple)
   * @param {string} message - Le message à afficher
   * @param {string} type - 'loading' ou 'success' pour le style
   */
  function displayPopup(message, type) {
    // Supprime toute popup existante pour ne pas en avoir plusieurs
    $('.drc-feedback-popup').remove();

    // Crée l'élément popup
    const $popup = $(
      `<div class="drc-feedback-popup drc-feedback-${type}">
                <p>${message}</p>
            </div>`
    );

    $body.append($popup);

    if (type === 'success') {
      // Fait disparaître la popup 'success' après 2 secondes
      setTimeout(function () {
        $popup.fadeOut(500, function () {
          $(this).remove();
        });
      }, 2000);
    }
    // La popup 'loading' sera supprimée par l'événement de rafraîchissement
  }

  /**
   * 1. Interception de l'action de suppression (bouton 'remove')
   */
  $body.on('click', '.product-remove > a, .woocommerce-cart-form__cart-item .remove', function (e) {
    // Empêcher l'action par défaut pour s'assurer que notre script s'exécute en premier,
    // mais laisser l'événement AJAX se déclencher normalement.

    // Affiche la popup "Suppression en cours..."
    displayPopup('Suppression en cours...', 'loading');
  });

  /**
   * 2. Interception des événements AJAX de WooCommerce
   */

  // Événement déclenché AVANT le rechargement du fragment de panier
  $body.on('removing_product_from_cart', function () {
    // On s'assure que la popup de chargement est bien visible si l'action a été initiée
    if ($('.drc-feedback-popup.drc-feedback-loading').length === 0) {
      displayPopup('Modification en cours...', 'loading');
    }
  });


  // Événement déclenché APRÈS le rechargement du fragment de panier
  $body.on('removed_product_from_cart', function () {
    // 1. Supprime la popup de chargement
    $('.drc-feedback-popup.drc-feedback-loading').remove();

    // 2. Affiche la popup de succès
    displayPopup('Suppression effectuée !', 'success');
  });

  // Gestion du changement de quantité (modification)
  $body.on('click', '.qty', function () {
    // Le changement de quantité ne déclenche pas toujours un AJAX immédiatement,
    // mais le fait lors du clic sur le bouton "Mettre à jour le panier" ou perte de focus.
    // C'est un peu plus délicat à intercepter directement que la suppression.

    // Nous allons nous fier aux événements AJAX généraux du panier.
  });

  // Événement après la mise à jour des fragments du panier (couvre suppression et quantité)
  $body.on('applied_coupon_in_checkout updated_wc_div', function () {
    // Cet événement couvre les mises à jour générales du panier (y compris la quantité).

    // 1. Supprime la popup de chargement (au cas où elle soit encore là)
    $('.drc-feedback-popup.drc-feedback-loading').remove();

    // 2. Affiche la popup de succès
    displayPopup('Modification effectuée !', 'success');
  });

  // Si on clique sur le bouton de mise à jour du panier, on affiche la popup de chargement
  $body.on('click', '.woocommerce-cart-form :submit[name="update_cart"]', function () {
    displayPopup('Modification en cours...', 'loading');
  });

});